import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import {
  GetNumberStudentsPerProfessionalInFieldUseCaseInterface,
  ExportNumberStudentsPerProfessionalInFieldUseCaseInterface,
} from 'domain/usecases';

export class RemoteGetNumberStudentsPerProfessionalInField
  implements GetNumberStudentsPerProfessionalInFieldUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetNumberStudentsPerProfessionalInFieldUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetNumberStudentsPerProfessionalInFieldUseCaseInterface.Params,
  ): Promise<GetNumberStudentsPerProfessionalInFieldUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, params),
      responseType: 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}

export class RemoteExportNumberStudentsPerProfessionalInField
  implements ExportNumberStudentsPerProfessionalInFieldUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<ExportNumberStudentsPerProfessionalInFieldUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ExportNumberStudentsPerProfessionalInFieldUseCaseInterface.Params,
  ): Promise<ExportNumberStudentsPerProfessionalInFieldUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, params),
      responseType: 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
